import createWebStorage from './createWebStorage';
export default createWebStorage('local');